import * as ACTION_TYPES from "../actions/action-types";
import EmailIntegration from "../components/Workflow/RightWorkflowPanel/EmailIntegration";

const initialState = {
  emailIntegrationScroll: false,
};

/**
 * setting states according to the type of actions
 * @param {*} state
 * @param {*} action
 * @returns {state}
 */
const projectWorkflows = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.ADD_PROJECT_WORKFLOW:
      return {
        ...state,
        [payload.projectId]: payload.workflows,
      };
    case ACTION_TYPES.DELETE_PROJECT_WORKFLOW:
      return {
        ...state,
        [payload.projectId]: state[payload.projectId]?.filter((workflow) => workflow.WorkflowId !== payload?.workflowId),
      };
    case ACTION_TYPES.EMAIL_INTEGRATION_SCROLL:
      return {
        ...state,
        emailIntegrationScroll: action.payload,
      };
    default:
      return state;
  }
};

export default projectWorkflows;
